var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 20c-2 2-2 4-4 4s-4-2-6-4-4-4-4-6 2-2 4-4-4-8-6-8-6 6-6 6c0 4 4.109 12.109 8 16s12 8 16 8c0 0 6-4 6-6s-6-8-8-6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.016 17.016v-1.5q0-1.125-1.711-1.828t-3.305-0.703-3.305 0.703-1.711 1.828v1.5h10.031zM12 6.75q-0.938 0-1.594 0.656t-0.656 1.594 0.656 1.594 1.594 0.656 1.594-0.656 0.656-1.594-0.656-1.594-1.594-0.656zM20.016 3.984q0.797 0 1.383 0.609t0.586 1.406v12q0 0.797-0.586 1.406t-1.383 0.609h-16.031q-0.797 0-1.383-0.609t-0.586-1.406v-12q0-0.797 0.586-1.406t1.383-0.609h16.031zM3.984 24v-2.016h16.031v2.016h-16.031zM20.016 0v2.016h-16.031v-2.016h16.031z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logo2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32 2.56c-3.176 0-5.76 2.584-5.76 5.76v15.36c0 3.176 2.584 5.76 5.76 5.76h15.36c0.216 0 0.429-0.014 0.64-0.038v-26.805c-0.211-0.024-0.424-0.038-0.64-0.038h-15.36zM25.6 2.896v6.064h3.84v-0.64c0-2.502-1.606-4.631-3.84-5.424zM14.080 7.68c4.588 0 8.32 3.732 8.32 8.32s-3.732 8.32-8.32 8.32c-4.588 0-8.32-3.732-8.32-8.32s3.732-8.32 8.32-8.32zM14.080 8.96c-3.882 0-7.040 3.158-7.040 7.040 0 1.801 0.686 3.441 1.802 4.688 1.327-1.343 3.223-2.128 5.237-2.128 2.010 0 3.913 0.782 5.24 2.125 1.115-1.246 1.8-2.885 1.8-4.685 0-3.882-3.158-7.040-7.040-7.040zM25.6 10.24v5.12h3.84v-5.12h-3.84zM14.080 11.84c1.588 0 2.88 1.292 2.88 2.88s-1.292 2.88-2.88 2.88c-1.588 0-2.88-1.292-2.88-2.88s1.292-2.88 2.88-2.88zM25.6 16.64v5.12h3.84v-5.12h-3.84zM25.6 23.040v6.064c2.234-0.793 3.84-2.921 3.84-5.424v-0.64h-3.84z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 20 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21.859c0 2.281-1.5 4.141-3.328 4.141h-13.344c-1.828 0-3.328-1.859-3.328-4.141 0-4.109 1.016-8.859 5.109-8.859 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c4.094 0 5.109 4.75 5.109 8.859zM16 8c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "up",
    viewBox: "0 0 28 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.297 20.797l-2.594 2.578c-0.391 0.391-1.016 0.391-1.406 0l-8.297-8.297-8.297 8.297c-0.391 0.391-1.016 0.391-1.406 0l-2.594-2.578c-0.391-0.391-0.391-1.031 0-1.422l11.594-11.578c0.391-0.391 1.016-0.391 1.406 0l11.594 11.578c0.391 0.391 0.391 1.031 0 1.422z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "down",
    viewBox: "0 0 28 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.297 12.625l-11.594 11.578c-0.391 0.391-1.016 0.391-1.406 0l-11.594-11.578c-0.391-0.391-0.391-1.031 0-1.422l2.594-2.578c0.391-0.391 1.016-0.391 1.406 0l8.297 8.297 8.297-8.297c0.391-0.391 1.016-0.391 1.406 0l2.594 2.578c0.391 0.391 0.391 1.031 0 1.422z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.b14a37c662e3eadc6f6800d18811c1a4.svg";
export { ForwardRef as ReactComponent };